import {
  KeyboardEventHandler,
  MouseEventHandler,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

interface SearchQueryContext {
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
  debouncedQuery: string;
}

export const SearchQueryContext = createContext<SearchQueryContext>({
  searchQuery: "",
  setSearchQuery: () => null,
  debouncedQuery: "",
});

interface useSearchQueryArgs {
  onSearchQueryChange?: () => void;
}

export const useSearchQuery = (args?: useSearchQueryArgs) => {
  const props = useContext(SearchQueryContext);

  const handleInputKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      props.setSearchQuery(e.currentTarget.value);
    }
  };

  const handleMouseDown: MouseEventHandler<HTMLFormElement> = (e) => {
    const input = e.currentTarget?.previousElementSibling as HTMLInputElement;
    if (
      !e.currentTarget?.previousElementSibling?.classList.contains(
        "hbs-search-box__input",
      )
    ) {
      return;
    }
    e.preventDefault();
    props.setSearchQuery(input.value);
  };

  const [prevSearchQuery, setPrevSearchQuery] = useState(props.searchQuery);
  useEffect(() => {
    if (prevSearchQuery !== props.searchQuery) {
      setPrevSearchQuery(props.searchQuery);
      if (args?.onSearchQueryChange) {
        args?.onSearchQueryChange();
      }
    }
  }, [prevSearchQuery, props.searchQuery, args]);

  return { ...props, handleInputKeyDown, handleMouseDown };
};
